import { useNavigate } from 'react-router'
import { RefreshCw, Settings, ArrowRight } from 'lucide-react'
import { Button } from './ui/button'
import { routes } from '@/lib/routes'

interface PropertiesEmptyStateProps {
  onRefresh: () => void
}

export function PropertiesEmptyState({ onRefresh }: PropertiesEmptyStateProps) {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-surface2">
        <Settings className="h-8 w-8 text-mint" />
      </div>
      <h2 className="mb-2 text-2xl font-semibold text-text">No properties yet</h2>
      <p className="mb-8 max-w-md text-sm text-textMuted">
        Sync properties from Uplisting to get started. Once you sync your first property, it will
        appear here.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button onClick={() => navigate(routes.operations.path)}>
          Go to Settings
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
        <Button variant="outline" onClick={onRefresh}>
          <RefreshCw className="mr-2 h-4 w-4" />
          Refresh
        </Button>
      </div>
    </div>
  )
}
